import type { User } from '../firebase/firebase';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestReturnSuccessStatus,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export type CreateNoteBody = {
	leaveID: string;
	note: string;
};

export const createLeaveNote = async (
	abortSignal: AbortSignal,
	user: User,
	leaveID: string,
	note: string,
): Promise<void> => {
	await makeCloudFunctionRequestReturnSuccessStatus<CreateNoteBody>({
		abortSignal,
		user,
		url: HTTPSCloudFunctionURLs.CreateLeaveNote,
		method: 'POST',
		services: defaultCloudFunctionServices,
		body: {
			leaveID,
			note,
		},
	});
};
